(ns arthur.flow.condition.brows
  "Condition measured brow shape and end heights in head-local space."
  (:require [arthur.domain.ring :as ring]
            [arthur.flow.condition :as condition]))

(defn- distance [a b]
  (js/Math.hypot (- (:x a) (:x b)) (- (:y a) (:y b))))

(defn- clamp01 [x] (max 0 (min 1 x)))

(defn- conditioned-side [rings raises corners
                          {:keys [fps contour-avg brow-gain brow-step brow-weight]}]
  (let [fps (or fps 30)
        rings (condition/contours {:contour-avg contour-avg} rings)
        w (/ (reduce + (map (fn [[a b]] (distance a b)) corners))
             (count corners))
        rest (condition/median-point raises)
        px (mapv (fn [{:keys [x y]}]
                   {:x (* (- x (:x rest)) brow-gain w)
                    :y (* (- y (:y rest)) brow-gain w)}) raises)
        cells (condition/quantize-snap px (* brow-step w)
                                       (js/Math.round (* fps 0.08)))]
    (let [frames (mapv (fn [shape [outer inner] measured snapped]
            (let [d-outer (- (:x measured) (:x snapped))
                  d-inner (- (:y measured) (:y snapped))
                  move (/ (+ d-outer d-inner) 2)
                  span (- (:x inner) (:x outer))
                  warped (mapv (fn [p]
                                 (let [t (if (< (abs span) 1e-9) 0
                                           (clamp01 (/ (- (:x p) (:x outer)) span)))]
                                   (update p :y + (+ (- d-outer move)
                                                     (* (- d-inner d-outer) t)))))
                               shape)]
              {:ring (ring/offset-ring warped (* brow-weight w))
               :pos [0 move]}))
          rings corners px cells)]
      {:rings (mapv :ring frames) :positions (mapv :pos frames)})))

(defn apply-defaults
  [params {:keys [ring-r ring-l raise-r raise-l] :as measured}
   {:keys [corners-r corners-l]}]
  (let [r (conditioned-side ring-r raise-r corners-r params)
        l (conditioned-side ring-l raise-l corners-l params)]
    (assoc measured
           :ring-r (:rings r) :ring-l (:rings l)
           :pos-r (:positions r) :pos-l (:positions l))))
